import React from "react"

import './video-bg-new.scss'

export const VideoBgNew = ( { title, videoId } ) => (
  //src="https://www.youtube.com/embed/GCcMvcawH3I?controls=0&showinfo=0&rel=0&autoplay=1&loop=1&mute=1&playlist=GCcMvcawH3I
  <div className="video-new-bg">
    <iframe
      title={ title }
      src={ `https://player.vimeo.com/video/${ videoId }?autoplay=1&loop=1&background=1&byline=0&title=0&muted=1` }
      frameBorder="0"
      webkitallowfullscreen="1"
      mozallowfullscreen="1"
      scrolling="no"
      allowFullScreen="">
    </iframe>
  </div>
)

export default VideoBgNew